'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";

// src/api/common/richText.ts
var RICHTEXT_QUERY = `
json
links {
  assets {
    block {${IMAGE_QUERY}}
  }
}`;

export {
  RICHTEXT_QUERY
};
//# sourceMappingURL=chunk-24EW7UVZ.mjs.map